import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import Home from "./container/Home/index";
import Properties from "./container/Properties/PropertiesIndex";
import Error404 from "./container/Error404/index";
import PropertyDetails from "./container/PropertyDetail/index";
import PermanentResidency from "./container/PermanentResidency/PermanentResidencyIndex";
import News from "./container/News/NewsIndex";
import NewsDetail from "./container/NewsDetail/index";
import Scrolltotop from "./components/Scroll-to-top/index";
import { ScrollFromBottom } from "./components/Scroll-to-top/ScrollFromBottom";
import CustomLoader from "./components/CustomLoader/index";

// Админка грузится отдельным файлом, посетителям сайта она не нужна
const AdminApp = lazy(() => import("./admin/AdminApp"));

// Кнопка «наверх» нужна только на сайте, не в админке
function SiteScrollButton() {
  const { pathname } = useLocation();
  return pathname.startsWith("/admin") ? null : <ScrollFromBottom />;
}

function App() {
  return (
    <div className="App">
      <Router>
        <Scrolltotop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/properties" element={<Properties />} />
          <Route path="/properties/:id" element={<PropertyDetails />} />
          <Route path="/permanent-residency/:id" element={<PermanentResidency />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/:id" element={<NewsDetail />} />
          <Route
            path="/admin/*"
            element={
              <Suspense fallback={<CustomLoader loading />}>
                <AdminApp />
              </Suspense>
            }
          />
          <Route path="*" element={<Error404 />} />
        </Routes>
        <SiteScrollButton />
      </Router>
    </div>
  );
}

export default App;
